import { j as e } from "../../../chunks/jsx-runtime.DGlMoOmv.js";
import { FormattedMessage as t } from "react-intl";
import { B as i } from "../../../chunks/Button.Ccj-dDdM.js";
import { T as s } from "../../../chunks/Text.BGhoO_e3.js";
import { A as m } from "../../../chunks/AvailabilityBlock.wTbqFj9F.js";
const f = ({
  dateBlocks: l,
  onConfirmPressed: r,
  onViewCalendarPressed: d,
  timeZone: o
}) => /* @__PURE__ */ e.jsxs("div", { className: "tw-w-full tw-min-w-[300px]", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "tw-text-center tw-mb-40", children: [
    /* @__PURE__ */ e.jsx(s, { typeface: "headline-3-b", className: "tw-block", children: /* @__PURE__ */ e.jsx(t, { id: "iTnblA", defaultMessage: [{
      type: 0,
      value: "Please confirm your upcoming weekend availability"
    }] }) }),
    /* @__PURE__ */ e.jsx(s, { typeface: "body-2", className: "tw-block tw-mt-16", children: /* @__PURE__ */ e.jsx(t, { id: "zPxgYg", defaultMessage: [{
      type: 0,
      value: "Did you know Saturdays are the most booked days for events? Please take a moment to confirm your availability or update your calendar."
    }] }) })
  ] }),
  /* @__PURE__ */ e.jsx("div", { className: "tw-space-y-12", children: l.map((a, n) => /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(m, { date: a.date, availability: a.availability, timeZone: o }) }, `${a.date}-${a.availability}-${n}`)) }),
  /* @__PURE__ */ e.jsxs("div", { className: "tw-mt-20 tw-space-y-8", children: [
    /* @__PURE__ */ e.jsx(i, { fullWidth: !0, onClick: r, children: /* @__PURE__ */ e.jsx(t, { id: "SEXlnF", defaultMessage: [{
      type: 0,
      value: "Confirm these dates"
    }] }) }),
    /* @__PURE__ */ e.jsx(i, { fullWidth: !0, variant: "outline-1", onClick: d, children: /* @__PURE__ */ e.jsx(t, { id: "gaL5xo", defaultMessage: [{
      type: 0,
      value: "View or edit calendar"
    }] }) })
  ] })
] });
export {
  f as AvailabilityEditor
};
//# sourceMappingURL=index.js.map
